/* PRODUCT SPECIFICATION accordion — moves the real spec list (<ul> or
   <ol>) that already lives inside product.description into the accordion
   panel, using the browser's own parsed DOM (appendChild = a real move,
   not a clone) rather than trying to string-parse the raw description
   HTML in Liquid, which is unsafe here: some product descriptions are
   pasted-in from elsewhere and wrap the actual content in several layers
   of unrelated markup (verified while auditing this catalogue) that a
   naive split on list tags could easily mishandle. Moving the parsed
   list node itself sidesteps all of that safely, regardless of how
   deeply nested or unusual the surrounding markup is.

   This is the authoritative check — a real DOM query, so it doesn't care
   about attributes/casing/whitespace on the tag the way a Liquid string
   match would. Liquid's own pre-check (see product-template.liquid) only
   decides whether to render the shell at all, as a cheap way to avoid an
   empty accordion (or JS having to remove one) on a product with no list;
   it's deliberately loose for the same reason, so the two checks should
   agree in practice, but this one is what actually matters. */
(function () {
  'use strict';

  document.querySelectorAll('[data-mbg-pdp-description]').forEach(function (description) {
    var accordion = description.parentElement && description.parentElement.querySelector('.mbg-spec-accordion');
    if (!accordion) {
      return;
    }

    var list = description.querySelector('ul, ol');
    var target = accordion.querySelector('[data-mbg-spec-content]');

    if (!list || !target) {
      accordion.remove();
      return;
    }

    target.appendChild(list);

    var summary = accordion.querySelector('.mbg-spec-accordion__summary');
    if (summary) {
      accordion.addEventListener('toggle', function () {
        summary.setAttribute('aria-expanded', accordion.open ? 'true' : 'false');
      });
    }
  });
})();
